/**
 * Authorization Types
 *
 * Core type definitions for the authorization system
 */

/**
 * Actions that can be performed on resources
 */
export enum Action {
  Create = "create",
  Read = "read",
  Update = "update",
  Delete = "delete",
  Approve = "approve",
  Manage = "manage", // Special action that grants all permissions
  Execute = "execute", // Execute operations like processing payments, transfers
  Report = "report", // Generate reports and analytics
}

/**
 * Subject types that can have permissions
 *
 * Organized by functional area for clarity.
 */
export enum Subject {
  // Special
  All = "all", // Reserved for Gently staff bypass only

  // Finance & Accounting
  APInvoice = "APInvoice",
  APInvoicePayment = "APInvoicePayment",
  ARInvoice = "ARInvoice",
  ARPayment = "ARPayment",
  GeneralLedger = "GeneralLedger",
  Account = "Account",
  Budget = "Budget",
  FixedAsset = "FixedAsset",

  // Sales & CRM
  SalesOrder = "SalesOrder",
  SalesOrderDraft = "SalesOrderDraft",
  Customer = "Customer",
  Contact = "Contact",
  ServiceTicket = "ServiceTicket",
  Payment = "Payment",

  // Purchasing
  PurchaseOrder = "PurchaseOrder",
  Supplier = "Supplier",

  // Inventory
  Product = "Product",
  Inventory = "Inventory",
  Warehouse = "Warehouse",

  // Organization & Administration
  User = "User",
  UserGroup = "UserGroup",
  OrganizationConfig = "OrganizationConfig",
  Division = "Division",
}

/**
 * Type representing a specific permission
 */
export interface Permission {
  action: Action;
  subject: Subject;
}
